import {Component, inject} from '@angular/core';
import {HeaderService} from '../../header.service';
import {take} from 'rxjs/operators';
import {Menu, MenuService, Weekday, WeekdayMenu, WeeklyMenu} from '../../services/menu/menu.service';

interface PlanImage {
    src: string;
    alt: string;
    caption: string;
}

@Component({
    selector: 'app-speiseplan',
    templateUrl: './speiseplan.component.html',
    styleUrls: ['./speiseplan.component.scss']
    })
export class SpeiseplanComponent {
    readonly impressions: PlanImage[] = [
        {
            src: 'assets/img/gallery/stube-04.jpg',
            alt: 'Gaststube der Marktstubn mit Zirbenholz',
            caption: 'Drinnen in der Marktstubn'
        },
        {
            src: 'assets/img/gallery/terrasse-02.jpg',
            alt: 'Gäste auf der Sonnenterrasse',
            caption: 'Draußen auf der Terrasse'
        },
        {
            src: 'assets/img/gallery/imbiss.jpg',
            alt: 'Imbiss- und Kaffeetheke',
            caption: 'Eingepackt für unterwegs'
        }
    ];

    weekdayMenuCollection: WeekdayMenu[] = [];
    weeklyMenuCollection: WeeklyMenu[] = [];
    currentWeekday: Weekday | undefined;

    /** The day shown in the spotlight – today, or the next weekday on a weekend. */
    spotlightWeekday: Weekday | undefined;
    spotlightMenus: Menu[] = [];
    menusLoaded = false;

    private menuService: MenuService = inject(MenuService);
    private headerService: HeaderService = inject(HeaderService);

    constructor() {
        this.headerService.setHeaderTitle('Speiseplan');
        this.headerService.setHeaderImage('assets/img/speiseplan/burger-banner.jpg');
        this.headerService.setHeaderContext('Gerichte aus dem Mittagsmenü & der Wochenkarte, frisch aus der ' +
            'Metzgerei. Zum Genießen in der Marktstubn & beim Mitnehmen.');

        this.currentWeekday = this.menuService.getCurrentWeekday();

        this.menuService.getWeekdayMenus()
            .pipe(take(1))
            .subscribe((weekdayMenus: WeekdayMenu[]): void => {
                this.weekdayMenuCollection = weekdayMenus;
                this.resolveSpotlight(weekdayMenus);
                this.menusLoaded = true;
            });

        this.menuService.getWeeklyMenus()
            .pipe(take(1))
            .subscribe((weeklyMenus: WeeklyMenu[]): void => {
                this.weeklyMenuCollection = weeklyMenus;
            });
    }

    get isSpotlightToday(): boolean {
        return !!this.currentWeekday && this.spotlightWeekday === this.currentWeekday;
    }

    hasMenu(weekdayMenu: WeekdayMenu): boolean {
        return !!weekdayMenu.menu1?.hauptspeise || !!weekdayMenu.menu2?.hauptspeise;
    }

    private resolveSpotlight(weekdayMenus: WeekdayMenu[]): void {
        const target: WeekdayMenu | undefined = this.currentWeekday
            ? weekdayMenus.find(weekdayMenu => weekdayMenu.day === this.currentWeekday)
            : weekdayMenus.find(weekdayMenu => this.hasMenu(weekdayMenu));

        if (!target || !this.hasMenu(target)) {
            return;
        }

        this.spotlightWeekday = target.day;
        this.spotlightMenus = [target.menu1, target.menu2]
            .filter((menu): menu is Menu => !!menu?.hauptspeise);
    }
}
